import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  params, string, arrayOf,
  shape, extend
} from '@thd-nucleus/data-sources';
import { DrawerHeader } from '@one-thd/sui-atomic-components';
import { MiniPip } from '../../common/mini-pip/MiniPip';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';

export const AddToCart = ({
  products: productsProp,
  productPodItemData
}) => {
  const {
    screen,
    setScreen,
    handleClose
  } = useContext(AddToContext);
  const [products, setProducts] = useState(productsProp);

  const itemId = products[0]?.itemId || productPodItemData?.itemId;

  const {
    MINI_PIP_PRODUCT_OVERVIEW,
    MINI_PIP_FULL
  } = SCREENS;

  const handleBackPress = () => {
    setScreen(MINI_PIP_FULL);
  };

  const showBackButton = screen === MINI_PIP_PRODUCT_OVERVIEW;

  return (
    <>
      <DrawerHeader
        data-testid="add-to-drawer-header"
        title="Product Quickview"
        onClose={handleClose}
        onBack={ showBackButton ? handleBackPress : null}
      />
      {
        screen?.startsWith('MINI_PIP') && (
          <MiniPip itemId={itemId} />
        )
      }
    </>
  );
};

AddToCart.displayName = 'AddToCart';

AddToCart.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string,
    quantity: PropTypes.number
  })),
  productPodItemData: PropTypes.shape({
    itemId: PropTypes.string,
    quantity: PropTypes.number,
    searchKeyword: PropTypes.string
  })
};

AddToCart.defaultProps = {
  products: [],
  productPodItemData: {}
};

AddToCart.dataModel = extend({
  product: params({
    itemId: string().isRequired(),
    dataSource: string()
  }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      brandName: string(),
      productType: string(),
      productLabel: string(),
      storeSkuNumber: string(),
      omsThdSku: string(),
      specialOrderSku: string()
    }),
    info: shape({
      productDepartment: string(),
      classNumber: string()
    }),
    media: shape({
      images: arrayOf(shape({
        url: string(),
        type: string(),
        subType: string()
      }))
    }),
    reviews: shape({
      ratingsReviews: shape({
        averageRating: string(),
        totalReviews: string()
      })
    })
  })
}
);
